import "./shippingAddressBody.scss";
import ShipmentInformation from "../../molecules/ShipmentInformation/ShipmentInformation";
import ShipmentMaterials from "../../molecules/ShipmentMaterials/ShipmentMaterials";

const ShippingAddressBody = ({
  restrictedItemsDrawer,
  setRestrictedItemsDrawer,
  country,
}) => {
  return (
    <div className="shipping-address-body-c">
      <ShipmentInformation country={country} />
      <ShipmentMaterials
        restrictedItemsDrawer={restrictedItemsDrawer}
        setRestrictedItemsDrawer={setRestrictedItemsDrawer}
      />
    </div>
  );
};

export default ShippingAddressBody;
